module.exports = {
    apiKey: "AIzaSyCpk9X8jI8nL_uGgh30d9QGC3sPWeJZ3hg",
    authDomain: "stack-sharer.firebaseapp.com",
    databaseURL:
        "https://stack-sharer-default-rtdb.firebaseio.com",
    projectId: "stack-sharer",
    storageBucket: "stack-sharer.appspot.com",
    messagingSenderId: "150299166815",
    appId: "1:150299166815:web:c66791b692f0236ec1f3ea",  
}